import store from "../../ReduxStore/store";

export const isOwner = (id) => {
    const profileId = store?.getState()?.profileData?.profileData?.profileId;
    return id === profileId
}